import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_DEPARTMENT,
  GET_DEPARTMENTS,
  ADD_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT
} from '@/queries/modules/common-data/department';

export async function getDepartments(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_DEPARTMENTS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setDepartments', data.getDepartments);
      context.commit('setSuccess', null);
      return data.getDepartments
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getDepartment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_DEPARTMENT,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setDepartment', data.getDepartment);
      context.commit('setSuccess', null);
      return data.getDepartment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addDepartment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_DEPARTMENT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const departments = [...context.state.departments];
      departments.push(data.addDepartment);
      context.commit('setDepartments', departments);
      context.commit('setSuccess', newItemSuccess(data.addDepartment.nameLocal));

      return data.addDepartment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateDepartment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_DEPARTMENT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.departments.findIndex(item => item.id === data.updateDepartment.id);
      const departments = [
        ...context.state.departments.slice(0, index),
        data.updateDepartment,
        ...context.state.departments.slice(index + 1)
      ];
      context.commit('setDepartments', departments);
      context.commit('setSuccess', updateItemSuccess(data.updateDepartment.nameLocal));

      return data.updateDepartment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteDepartment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_DEPARTMENT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.departments.findIndex(item => item.id === data.deleteDepartment.id);
      const departments = [
        ...context.state.departments.slice(0, index),
        ...context.state.departments.slice(index + 1)
      ];
      context.commit('setDepartments', departments);
      context.commit('setSuccess', deleteItemSuccess(data.deleteDepartment.nameLocal));

      return data.deleteDepartment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

